import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const DebugLogList = Loadable(lazy(() => import('./DebugLogList')));

const DebugLogRoutes = [
	{
		path: '/debuglog',
		element: <DebugLogList />,
		auth: authRoles.admin,
	},
];

export default DebugLogRoutes;
